export const areUnorderedArrayValuesEqual = <T extends string>(
  a: readonly T[] | undefined,
  b: readonly T[] | undefined
): boolean => {
  if (a === b) return true;
  if (!a || !b) return false;
  if (a.length !== b.length) return false;

  const counts = new Map<T, number>();
  for (const value of a) {
    counts.set(value, (counts.get(value) ?? 0) + 1);
  }

  for (const value of b) {
    const count = counts.get(value);
    if (!count) return false;
    if (count === 1) counts.delete(value);
    else counts.set(value, count - 1);
  }

  return counts.size === 0;
};
